<template>
    <v-card flat class="card">
        <div class="w-100 h-100 pa-8 d-flex flex-column ga-6">
            <span class="text-heading text-primary">Intakevragenlijst afsluiten?</span>
            <span class="text-normal text-primary">De vragenlijst dien je in één keer in te vullen; tussentijds opslaan is
                niet mogelijk.
                Daarnaast willen we je erop attenderen dat je abonnement doorloopt, ook als je deze vragen niet hebt
                ingevuld.</span>
            <div class="">
                <v-btn rounded flat color="secondary" size="large" @click="$emit('back')">Terug naar de vragen</v-btn>
            </div>
        </div>
    </v-card>
</template>